import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        menuIndex: '',
    },
    mutations: {
        menuIndex(state, index) {
            state.menuIndex = index
        },
    },
    actions: {},
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
        }),
    ],
})



// WEBPACK FOOTER //
// ./src/store/index.js